// extracted by mini-css-extract-plugin
export default {"map":"style_map__XD-XH","places_container":"style_places_container__h+olh"};